import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UserService from "../../services/userService";
import { handleApiError } from "../../api/handleApiError";

export const fetchAllDesignations = createAsyncThunk(
    "designation/fetchAllDesignations",
    async (params = {}) => {
        return (await UserService.getAllDesignations(params)).data.data || [];
    }
);

export const createDesignation = createAsyncThunk(
    "designation/createDesignation",
    async (payload, thunkAPI) => {
        try {
            return (await UserService.createDesignation(payload)).data.data;
        } catch (e) {
            return handleApiError(e, thunkAPI, "create designation error");
        }
    }
);

export const updateDesignation = createAsyncThunk(
    "designation/updateDesignation",
    async ({ id, data }, thunkAPI) => {
        try {
            return (await UserService.updateDesignation(id, data)).data.data;
        } catch (e) {
            return handleApiError(e, thunkAPI, "update designation error");
        }
    }
);

export const deleteDesignation = createAsyncThunk(
    "designation/deleteDesignation",
    async (id, thunkAPI) => {
        try {
            await UserService.deleteDesignation(id);
            return id;
        } catch (e) {
            return handleApiError(e, thunkAPI, "delete designation error");
        }
    }
);

const designationSlice = createSlice({
    name: "designation",
    initialState: {
        designationList: [],
        totalRecords: 0,
        loading: false,
        isSuccess: false,
        errorMessage: null,
    },
    reducers: {
        resetStatus: (state) => {
            state.isSuccess = false;
            state.errorMessage = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllDesignations.pending, (s) => {
                s.loading = true;
                s.errorMessage = null;
            })
            .addCase(fetchAllDesignations.fulfilled, (s, a) => {
                s.loading = false;
                s.designationList = a.payload || [];
            })
            .addCase(fetchAllDesignations.rejected, (s, a) => {
                s.loading = false;
                s.errorMessage = a.payload || "Error";
            })
            .addCase(createDesignation.pending, (s) => {
                s.loading = true;
                s.isSuccess = false;
                s.errorMessage = null;
            })
            .addCase(createDesignation.fulfilled, (s, a) => {
                s.loading = false;
                s.isSuccess = true;
                if (a.payload) s.designationList = [a.payload, ...(s.designationList || [])];
            })
            .addCase(createDesignation.rejected, (s, a) => {
                s.loading = false;
                s.isSuccess = false;
                s.errorMessage = a.payload || "Error";
            })
            .addCase(updateDesignation.pending, (s) => {
                s.loading = true;
                s.isSuccess = false;
                s.errorMessage = null;
            })
            .addCase(updateDesignation.fulfilled, (s, a) => {
                s.loading = false;
                s.isSuccess = true;
                const updated = a.payload;
                if (!updated?.id) return;
                s.designationList = (s.designationList || []).map((d) => (d.id === updated.id ? updated : d));
            })
            .addCase(updateDesignation.rejected, (s, a) => {
                s.loading = false;
                s.isSuccess = false;
                s.errorMessage = a.payload || "Error";
            })
            .addCase(deleteDesignation.pending, (s) => {
                s.loading = true;
                s.isSuccess = false;
                s.errorMessage = null;
            })
            .addCase(deleteDesignation.fulfilled, (s, a) => {
                s.loading = false;
                s.isSuccess = true;
                s.designationList = (s.designationList || []).filter((d) => d.id !== a.payload);
            })
            .addCase(deleteDesignation.rejected, (s, a) => {
                s.loading = false;
                s.isSuccess = false;
                s.errorMessage = a.payload || "Error";
            });
    },
});

export const { resetStatus } = designationSlice.actions;
export default designationSlice.reducer;